<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted () {},
  data () {
    return {};
  },
  watch: {
    $route (to, from) {
      document.title = to.meta.title || 'Suite - DINAPSIS Hubgrade by Veolia';
    }
  }
};
</script>
<style lang="scss" scoped>
#app {
  background-color: rgba(233, 244, 246, 0.5) !important;
}

</style>
